import { RequestBuilder } from "../requestBuilder";
import { CreateNamedConceptInputSchema, NamedConceptSchema } from "./namedConceptClient.types";

export const CreateNamedConceptRequestConfig = new RequestBuilder({
  path: () => "/named-concepts",
  responseSchema: NamedConceptSchema,
  bodySchema: CreateNamedConceptInputSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();
